import { FC, ReactNode } from "react";

interface PageItemProps {
    number: ReactNode;
    active?: boolean;
    onClick: () => void;
    disabled?: boolean;

}

export const PageItem: FC<PageItemProps> = ({
    number,
    active,
    onClick,
    disabled,
}) => {
    let classNames = active ? "bg-sky-950 hover:bg-sky-900 text-white" : "bg-white hover:bg-sky-100 text-sky-950";
    if (disabled) {
        classNames = "text-slate-200 cursor-default no-mouse-events";
    }

    classNames += " box-border p-2 w-10 sm:w-12 h-10 sm:h-12 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300 font-medium text-lg";

    return (
        <div
            style={{ fontFamily: 'Futura, sans-serif' }}
            className={classNames} onClick={onClick}
        >
            {number}
        </div>
    );
}